@if (isSmallScreen) {
  <div class="td-wb-responsive-option__container">
    <div [translate]="usingResponsive?
  'tdWb.components.responsiveOption.WATCH_MOBILE_LABEL' : 'tdWb.components.responsiveOption.WATCH_DESKTOP_LABEL'"></div>
    <a class="td-wb-responsive-option__link"
       href=""
       (click)="toggle()">
    <span [translate]="usingResponsive?
  'tdWb.components.responsiveOption.VIEW_DESKTOP_VERSION_LINK' : 'tdWb.components.responsiveOption.VIEW_MOBILE_VERSION_LINK'"></span>
    </a>
  </div>
}
